export default __webpack_public_path__ + "static/roundedlogo-01-429a2c87367ac13765a9bc796ff4e197.png";